<button
  [class]="triggerClass()"
  matRipple
  ngMenuTrigger
  #origin
  #trigger="ngMenuTrigger"
  type="button"
  [menu]="panel()?.menuRef()"
  [attr.aria-label]="triggerAriaLabel()"
>
  <ng-content />
</button>

<ng-template
  [cdkConnectedOverlayOpen]="trigger.expanded()"
  [cdkConnectedOverlay]="{ origin, usePopover: 'inline' }"
  [cdkConnectedOverlayPositions]="positions()"
  cdkAttachPopoverAsChild
>
  <immo-menu-panel
    [actions]="actions()"
    [headerTemplate]="header()?.template"
    (actionSelected)="actionSelected.emit($event)"
  />
</ng-template>
